import { compactMeta } from "./index";
import type { CompactContent, CompactMeta, CompactPage } from "./types";

type ContentModule = { content: Record<string, CompactContent> };

/** Innehållet per vertikal laddas som egna paket. */
function importContent(meta: CompactMeta): Promise<ContentModule> {
  switch (meta.vertical) {
    case "elavtal":
      return meta.kind === "bransch"
        ? import("./content/elavtal-branscher")
        : import("./content/elavtal-situationer");
    case "laddboxar":
      return import("./content/laddboxar");
    case "solceller":
      return import("./content/solceller");
    case "batterier":
      return import("./content/batterier");
    case "varmepumpar":
      return import("./content/varmepumpar");
  }
}

/** Hämtar en hel compact-sida, eller null om slugen inte är en compact-sida. */
export async function loadCompactPage(vertical: string, slug: string | undefined): Promise<CompactPage | null> {
  const meta = compactMeta(vertical, slug);
  if (!meta) return null;
  const mod = await importContent(meta);
  const content = mod.content[meta.slug];
  return content ? { ...meta, ...content } : null;
}
